import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import lesPage from './lesPage';
import Base from '@/gikam/js/components/base.js';
import Gikam from 'gikam';
import { I18N } from '@/gikam/i18n/I18N';
var _appendComps = [];
var sectionButtons = {};
var defaultOptions = {
  printCss: [],
  printMargin: '20 20 20 20',
  // 实例下富文本组件是否用ckeditor控件渲染
  ckeditorInstance: true,
  // spread表格动态属性
  spread: {
    editingHeight: 800,
    showHeader: true
  }
};

var Les = /*#__PURE__*/function (_Base) {
  _inherits(Les, _Base);

  var _super = _createSuper(Les);

  function Les(options) {
    var _this;

    _classCallCheck(this, Les);

    _this = _super.call(this);
    options.appendComps = _appendComps;
    options.sectionButtons = sectionButtons;

    _this.initialize(options, defaultOptions);

    if (!options.instance) {
      new lesPage(_this.options);
    } else {
      _this.creatInstance();
    }

    return _this;
  }

  _createClass(Les, [{
    key: "createLesPage",
    value: function createLesPage(row) {
      var _row = Gikam.deepExtend(this.options, row);

      if (Gikam.isNotEmpty(row.readonlyFlag)) {
        _row.readonly = row.readonlyFlag === '1' ? 'true' : 'false';
      } else if (Gikam.isNotEmpty(this.options.readonly)) {
        _row.readonly = this.options.readonly;
      } else {
        _row.readonly = 'false';
      }

      this.les = new lesPage(_row);
    }
  }, {
    key: "creatInstance",
    value: function () {
      var _creatInstance = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var gridData, toolbarDom, gridConfig, layout;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                gridData = this.options.gridData || [];
                toolbarDom = this.$parent.$toolbar;

                if (toolbarDom) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                toolbarDom.style.height = '30px';

                gridConfig = function gridConfig() {
                  return {
                    type: 'grid',
                    id: 'les-instances-table',
                    columnResize: false,
                    height: '100%',
                    page: false,
                    data: gridData.length > 1 ? gridData : [],
                    url: !(gridData.length > 1) && Gikam.IFM_CONTEXT + '/secure/core/les/les-instances/queries',
                    toolbar: [],
                    genericQuery: false,
                    columnsFill: true,
                    filter: false,
                    filterOpen: false,
                    generalButtonGroup: false,
                    requestData: {
                      id_IN: _this2.options.id
                    },
                    columns: [{
                      field: 'instanceName',
                      title: I18N.prop('les.comment.fields.instance.name'),
                      sort: false
                    }],
                    onRendered: function onRendered() {
                      Gikam.jQuery('.grid.columns-fill')[0].style.padding = '3px';
                      setTimeout(function () {
                        Gikam.jQuery('#les-instances-table table')[0].style.width = '100%';
                        Gikam.jQuery('#les-instances-table table')[1].style.width = '100%';
                      }, 500);
                    },
                    onRowActive: function onRowActive(index, row) {
                      toolbarDom.innerHTML = '';
                      layout.options.center.$dom.innerHTML = '';
                      row.renderTo = layout.options.center.$dom;
                      row.$parent_toolbar = toolbarDom;

                      _this2.createLesPage(row);
                    },
                    onLoadSuccess: function onLoadSuccess() {
                      this.activeRowByIndex(0);
                    }
                  };
                };

                layout = Gikam.create('layout', {
                  renderTo: this.options.renderTo,
                  west: {
                    width: gridData.length > 1 ? 150 : 0,
                    items: [gridConfig()]
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function creatInstance() {
        return _creatInstance.apply(this, arguments);
      }

      return creatInstance;
    }()
  }, {
    key: "showLesWest",
    value: function showLesWest() {
      document.getElementById('les-instances-table').parentElement.parentElement.style.display = 'block';
    }
  }], [{
    key: "appendComps",
    value: function appendComps(comps) {
      _appendComps = _appendComps.concat(comps);
    }
  }, {
    key: "cleanComps",
    value: function cleanComps() {
      _appendComps = [];
    }
  }, {
    key: "appendSectionButtons",
    value: function appendSectionButtons(buttons) {
      buttons.forEach(function (obj) {
        var unitCategory = obj.unitCategory;

        if (sectionButtons[unitCategory]) {
          sectionButtons[unitCategory].push(obj);
        } else {
          sectionButtons[unitCategory] = [obj];
        }
      });
    }
  }]);

  return Les;
}(Base);

export { Les as default };